import React, {ChangeEventHandler, ReactElement} from "react";
import {EditBrandMapBodyFrontend} from "./BrandMapFormValues";

interface Props {
	formValues: EditBrandMapBodyFrontend;
	inputOnChange: (key: keyof EditBrandMapBodyFrontend) => ChangeEventHandler<HTMLInputElement>;
}

function EditBrandMapMainPromoTitle(props: Props): ReactElement {

	return (
		<div className="create-map-page_container create-map-page_main-promo">
			<div className="create-map-page_container_inner create-map-page_main-promo_title">
				<h5>
					Main Promotion Title
				</h5>
				<p>
					Write a title for your main promotion. This will only appear if there is a main promotion set.
				</p>
				<input
					placeholder="Eg. Claim Rewards"
					value={props.formValues.promoTitle}
					onChange={props.inputOnChange("promoTitle")}
				/>
			</div>
		</div>
	);
}

export default EditBrandMapMainPromoTitle;
